
import EventsList from "../components/EventsList";

const BerlinPage = () => EventsList('Berlin')

export default BerlinPage;